import { useQuery } from '@tanstack/react-query';
import { accountQuery } from '@/api';
import { useChatWidget } from './useChatWidget';

/**
 * Long-lived chat bootstrap. Mount in RootLayout so auth NeedHelp
 * (`sportsbook:open-chat`) works even when AppShell is skipped.
 */
export function ChatHost() {
  const { data: account } = useQuery(accountQuery());
  useChatWidget(account);

  // Comm100 mounts into #livechat. Do not use the `hidden` attribute — that
  // would hide the chat panel itself when opened from the mobile footer.
  return <div id="livechat" className="pointer-events-none fixed" aria-hidden />;
}
